import { render, staticRenderFns } from "./MultipleChats.vue?vue&type=template&id=fa704d12&"
import script from "./MultipleChats.vue?vue&type=script&lang=js&"
export * from "./MultipleChats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports